module.exports = __webpack_public_path__ + "img/whited.d7ce67a9.png";